/**
 * Skeleton loading state for activity cards
 * Provides visual feedback while data is loading
 */
export default function LibraryActivitySkeleton() {
  return (
    <div className="flex gap-3 md:gap-4 py-3 md:py-4 animate-pulse">
      {/* Thumbnail Skeleton */}
      <div
        className="flex-shrink-0 rounded-lg bg-gray-200"
        style={{
          width: '124px',
          height: '93px',
        }}
      />

      {/* Content Skeleton */}
      <div className="flex-1 min-w-0">
        {/* Title Lines */}
        <div className="h-5 bg-gray-200 rounded w-3/4 mb-2" />
        <div className="h-5 bg-gray-200 rounded w-1/2 mb-3" />

        {/* Metadata Skeleton */}
        <div className="flex gap-3">
          <div className="h-4 bg-gray-200 rounded w-16" />
          <div className="h-4 bg-gray-200 rounded w-20" />
          <div className="h-4 bg-gray-200 rounded w-24" />
        </div>
      </div>
    </div>
  );
}

/**
 * Render multiple skeleton loaders
 */
export function LibrarySkeletonList({ count = 5 }: { count?: number }) {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index}>
          <LibraryActivitySkeleton />
          {index < count - 1 && (
            <div className="border-b border-gray-200" />
          )}
        </div>
      ))}
    </>
  );
}
